import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { User, CreateUserData, EditUserData, Company } from "../../store/types";
import UserDialogs from "../Dialogs/UserDialogs";
import { Button } from "primereact/button";
import { IconPlus } from "../../assets/icons/Icon";
import { Label } from "../../styles/PageLayoutStyles.styles";

interface AddUserProps {
  company?: Company;
  handleAddUser: (
    user: CreateUserData
  ) => Promise<{ success: boolean; user?: User; token?: string }>;
  handleEditUser: (user: EditUserData) => Promise<boolean>;
  handleDeleteUser: (user: User) => Promise<boolean>;
  refetchData: () => {};
  isMobile?: boolean;
}

const AddUserDialogButton: React.FC<AddUserProps> = ({
  company,
  handleAddUser,
  handleEditUser,
  handleDeleteUser,
  refetchData,
  isMobile = false,
}) => {
  const navigate = useNavigate();
  const [dialogVisible, setDialogVisible] = useState<boolean>(false);

  const handleCreate = () => {
    if (isMobile) {
      if (company) navigate(`/companies/${company.id}/users/form?mode=create`);
    } else {
      setDialogVisible(true);
    }
  };

  const handleDialogHide = () => {
    setDialogVisible(false);
  };

  return (
    <>
      <Button onClick={handleCreate}>
        <IconPlus size={16} />
        <Label>Новый пользователь</Label>
      </Button>
      {dialogVisible && (
        <UserDialogs
          visible={dialogVisible}
          onHide={handleDialogHide}
          dialogType={"create"}
          company={company}
          handleAddUser={handleAddUser}
          handleEditUser={handleEditUser}
          handleDeleteUser={handleDeleteUser}
          refetchData={refetchData}
        />
      )}
    </>
  );
};

export default AddUserDialogButton;
